import { useFetch } from "@app/framework/hooks";
import { apiUrls, URLS } from "@app/shared";
import { Link } from "@design-system/components";
import { Pagination } from "@design-system/components/Pagination";
import { PaginationInfo } from "@design-system/types";
import { AnnouncementReport } from "@modules/financial-information/types";
import { Loading } from "@modules/shared/components";
import { getCurrentLocaleCode } from "@mongez/localization";
import { useEffect } from "react";

export function AnnouncementsTab() {
  const locale = getCurrentLocaleCode();
  const { data, load, isLoading } = useFetch<{
    posts: AnnouncementReport[];
    paginationInfo: PaginationInfo;
  }>(apiUrls.generalAssembly.announcements);

  useEffect(() => {
    load();
  }, [locale]);

  return (
    <div className="flex animate-fade flex-col gap-8">
      {/* <p className="text-sm font-medium text-marine sm:text-base lg:text-lg">
        {trans("financialReportsDescription")}
      </p> */}
      <div className="flex flex-col gap-6 rounded-3xl bg-white p-4 md:gap-8 md:p-8">
        {/* <p className="text-lg font-medium text-bright-orange">
          {trans("quarterlyReports")}
        </p> */}
        {/* <FancyBox> */}
        {isLoading ? (
          <Loading />
        ) : (
          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-[repeat(auto-fill,minmax(270px,1fr))] gap-4">
              {data?.posts?.map((record, index) => (
                <AnnouncementItem key={index} record={record} />
              ))}
            </div>
            {data?.paginationInfo && (
              <Pagination
                onPageChange={(page) => {
                  load({ page });
                }}
                pushToHistory={false}
                paginationInfo={data.paginationInfo}
              />
            )}
          </div>
        )}
        {/* </FancyBox> */}
      </div>
    </div>
  );
}

type ReportItemProps = {
  record: AnnouncementReport;
};

function AnnouncementItem({ record }: ReportItemProps) {
  return (
    <Link
      to={URLS.investor.generalAssembly.announcements.view(record.id)}
      title={record.title}
      className="group flex shrink-0 cursor-pointer flex-col gap-4 overflow-hidden rounded-3xl border border-[#E0E0E0] bg-white p-4 shadow-sm transition-colors duration-300 hover:bg-gray-100"
    >
      {/* <div className="h-36 overflow-hidden rounded-2xl">
        <img
          src={record.image.url || annualReportImage}
          alt={record.title}
          className="h-full w-full object-cover transition-all duration-300 group-hover:scale-105"
        />
      </div> */}
      {/* <span className="gap-2 text-sm text-secondary">
        {formatDate(record.createdAt.timestamp, "dd MMMM yyyy")}
      </span> */}
      <p className="font-semibold text-marine group-hover:underline prose-table:border">
        {record.title}
      </p>
    </Link>
  );
}
